import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowShareLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowShareLeft"><Path d="M11.9993 7.75876V2.10547L0.605469 12.0001L11.9993 21.8948V16.255C15.7478 16.3049 17.7737 16.7361 19.0171 17.4096C20.2882 18.0981 20.8255 19.0796 21.5785 20.5855L22.9993 20.2501C22.9993 15.972 22.3811 12.7824 20.4943 10.6859C18.7002 8.69244 15.9139 7.85113 11.9993 7.75876Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowShareLeft;
